import { DefaultValues } from "react-hook-form";
import * as yup from "yup";

export const studioLinkPageItemSchema = yup
  .object({
    id: yup.number().default(0).defined(),
    name: yup
      .string()
      .trim()
      .required("Името е задължително")
      .max(200, "Името може да е най-много 200 символа")
      .defined(),
    url: yup
      .string()
      .trim()
      .required("Линкът е задължителен")
      .max(2048, "Линкът е твърде дълъг")
      .defined(),
    // Suggested from the link's domain and editable afterwards. Optional: an empty field means
    // the button falls back to the emoji or the first letter of its name.
    iconUrl: yup
      .string()
      .trim()
      .default("")
      .max(2048, "Адресът на иконата е твърде дълъг")
      .defined(),
  })
  .required();

export type IStudioLinkPageItemFormModel = yup.InferType<
  typeof studioLinkPageItemSchema
>;

export const studioLinkPageItemFormDefaultValues: DefaultValues<IStudioLinkPageItemFormModel> =
  {
    id: 0,
    name: "",
    url: "",
    iconUrl: "",
  };
